import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function signupReducer(state = initialState.signup, action) {
  switch (action.type) {
    case types.GET_SIGNUP_OPTIONS_SUCCESS:
      return action.data;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/signupReducer.js